import { Button, ConfigProvider, theme, App as AntdApp } from 'antd'
import { RouterProvider, createHashRouter, createRoutesFromElements } from 'react-router-dom'
import { StyleProvider } from '@ant-design/cssinjs'
import 'dayjs/locale/zh-cn'
import dayjs from 'dayjs'
import locale from 'antd/locale/zh_CN'
import routes from './router'
import { customTheme } from './config/theme'
import { getUnitAliasList, getUnitCollection, refreshSession } from './api/common/base'
import useGlobalStore from './store/useGlobalStore'
import { withTranslation } from 'react-i18next';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorBoundaryPage from './pages/error/ErrorBoundaryPage'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { useEffect } from 'react'
import ExportTaskProvider from './components/ExportTaskProvider'

dayjs.locale('zh-cn')
function App() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 5 * 60 * 1000, // 数据5分钟内认为是新鲜的
        gcTime: 10 * 60 * 1000,   // 改为 gcTime，垃圾回收时间为10分钟
      },
    },
  })
  const router = createHashRouter(createRoutesFromElements(routes))

  // 应用挂载时清空缓存
  // useEffect(() => {
  //   queryClient.clear(); // 应用挂载时清空所有查询
  // }, [queryClient]);

  return <QueryClientProvider client={queryClient}>
    <ConfigProvider
      locale={locale}
      theme={{
        // algorithm: theme.defaultAlgorithm,
        // algorithm: theme.darkAlgorithm,
        token: customTheme,
        // algorithm: [theme.compactAlgorithm],
        components: {
          Button: {
            // contentLineHeight: 36,
            colorPrimary: '#288DFF',
            paddingInline: '15',
            algorithm: true, // 启用算法
          },
          Splitter: {
            splitTriggerSize: 12,
            colorFill: '#288DFF',
            controlItemBgActiveHover: '#288DFF',
            controlItemBgActive: '#288DFF',
            controlItemBgHover: 'rgba(0, 0, 0, 0.1)'
          }
        },
      }}
    >
      <AntdApp message={{ maxCount: 1 }} >
        <ExportTaskProvider>
          <ErrorBoundary FallbackComponent={ErrorBoundaryPage}>
            <RouterProvider router={router} />
          </ErrorBoundary>
        </ExportTaskProvider>
      </AntdApp>
      {/* <StyleProvider hashPriority='high'> */}
      {/* </StyleProvider> */}
    </ConfigProvider>
  </QueryClientProvider>
}

export default App
// export default withTranslation()(App)
